import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SharedHeader from '../shared/SharedHeader';
import { venuePortalAPI } from '../../services/api';
import { useToast } from '../shared/ToastNotification';
import { useAuth } from '../../contexts/AuthContext';

const VenuePortalLogin = () => {
  const navigate = useNavigate();
  const { showError } = useToast();
  const { isAuthenticated, loading, signInWithGoogle } = useAuth();
  const [checkingAccess, setCheckingAccess] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!isAuthenticated) return;
      setCheckingAccess(true);
      try {
        await venuePortalAPI.getDashboard({ silent: true });
        if (!cancelled) navigate('/venue-portal/dashboard', { replace: true });
      } catch (err) {
        if (!cancelled && err?.status && err.status !== 401) {
          showError(err?.message || 'Venue portal access is not active for this account.');
        }
      } finally {
        if (!cancelled) setCheckingAccess(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [isAuthenticated, navigate, showError]);

  const handleContinue = async () => {
    const result = await signInWithGoogle();
    if (result?.error) {
      showError(result.error.message || 'Unable to start sign-in');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-[#10121f] to-[#070913] text-white">
      <SharedHeader />
      <div className="mx-auto flex w-full max-w-md flex-col px-6 pb-24 pt-16">
        <div className="rounded-xl border border-glass bg-white/5 p-8 shadow-2xl shadow-black/40">
          <h1 className="text-2xl font-semibold text-white">Venue portal</h1>
          <p className="mt-2 text-sm text-white/70">
            Sign in with the Google account linked to your venue. STAGSTER ops can grant access from the admin panel.
          </p>

          <button
            type="button"
            disabled={loading || checkingAccess}
            onClick={handleContinue}
            className="mt-6 w-full rounded-md bg-white px-4 py-3 text-sm font-semibold text-black transition hover:bg-white/90 disabled:cursor-not-allowed disabled:bg-white/60"
          >
            {checkingAccess ? 'Checking access…' : 'Sign in with Google'}
          </button>

          <div className="mt-6 rounded-md border border-glass bg-black/40 p-3 text-xs text-white/60">
            <p className="font-semibold text-white/80">Access model</p>
            <p className="mt-1">
              Venue owners no longer use a separate password silo. Access is attached to the same STAGSTER account system as the rest of V2.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenuePortalLogin;
